import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class DifficultyComponent extends Component {
  static readonly TYPE_ID: string = 'd7ba1b6518864549ac6f070cb2614bfa';

  constructor(
    public readonly difficulty: number,
  ) {
    super();
  }

  get $typeId() {
    return DifficultyComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): DifficultyComponent {
    return new DifficultyComponent(
        MapUtils.get<number>(map, 'difficulty'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'difficulty': this.difficulty,
    };
  }

  clone(): this {
    return new DifficultyComponent(
        this.difficulty,
    ) as this;
  }

  isSame(other: DifficultyComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.difficulty === this.difficulty;
  }
}

export class DifficultyComponentBuilder extends DataModelBuilder<DifficultyComponent> {
  build(context: SerializationContext, map: SerializedData): DifficultyComponent {
    return DifficultyComponent.fromMap(context, map);
  }
}
